// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cart-summary[data-v-70c686b6] {\n  margin: 40px 0;\n}", ""]);
// Exports
module.exports = exports;
